export default __webpack_public_path__ + "static/media/step4.171560c8.webp";